const getTotalPaidPayments = (data) => {
  if (data?.order?.payments?.length) {
    return data.order.payments
      .filter((i) => i.status === 'succeeded' || i.status === 'refunded')
      .reduce((acc, obj) => {
        return acc + Number(obj.orderPaymentAmount);
      }, 0);
  }
};

export default getTotalPaidPayments;
